export const getSubdomain = (): string => {
  return window.location.host.split('.')[0];
};

export const isActiveRoute = (
  location: string | { pathname: string },
  uri: string | { pathname: string },
  client?: {
    id: string | null;
  }
): boolean => {
  if (typeof uri !== 'string') return false;
  if (typeof location === 'string') return location.includes(uri.split('/')[client?.id ? 3 : 1]);

  if (location.pathname.includes('wizard')) return false;

  const maxIndex = client?.id ? 2 : 0;
  const segment = location.pathname
    .split('/')
    .filter(Boolean)
    .reduce((result, item, index) => (index > maxIndex ? result : result.concat(`/${item}`)), '');

  return uri.startsWith(segment);
};
